/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Action creators for the location module
 */

import type { CurrentSearch } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import {
  BOX_CHANGED,
  CENTER_CHANGED,
  CITY_NAME_CHANGED,
  CLEAR_CITY_NAME,
  CLEAR_HOOD_NAME,
  CLEAR_STATE_NAME,
  HOOD_NAME_CHANGED,
  STATE_NAME_CHANGED,
  URL_CHANGED,
  ZOOM_CHANGED,
} from './constants'

type CurrentSearchLocation = CurrentSearch['location']

export const boxChanged = createAction<CurrentSearchLocation['box'], typeof BOX_CHANGED>(
  BOX_CHANGED
)

export const centerChanged = createAction<
  { readonly lat: number | null; readonly lng: number | null },
  typeof CENTER_CHANGED
>(CENTER_CHANGED)

export const zoomChanged = createAction<number, typeof ZOOM_CHANGED>(ZOOM_CHANGED)

export const cityNameChanged = createAction<string, typeof CITY_NAME_CHANGED>(CITY_NAME_CHANGED)
export const clearCityName = createAction<typeof CLEAR_CITY_NAME>(CLEAR_CITY_NAME)
export const hoodNameChanged = createAction<string, typeof HOOD_NAME_CHANGED>(HOOD_NAME_CHANGED)
export const clearHoodName = createAction<typeof CLEAR_HOOD_NAME>(CLEAR_HOOD_NAME)
export const stateNameChanged = createAction<string, typeof STATE_NAME_CHANGED>(STATE_NAME_CHANGED)
export const clearStateName = createAction<typeof CLEAR_STATE_NAME>(CLEAR_STATE_NAME)

export const urlChanged = createAction<CurrentSearchLocation['url'], typeof URL_CHANGED>(
  URL_CHANGED
)
